"use client";

import React from "react";
import { Crown, Briefcase, Users, HeartHandshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function IndyServiceCircle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    title: "Bodas\xA0",
    description: "Elegant catering for your special union, tailored to your tastes.",
    icon: HeartHandshake
  }, {
    title: "Quinceañeras",
    description: "Celebrating coming of age with vibrant flavors and festive presentation.",
    icon: Crown
  }, {
    title: "Eventos de Trabajo",
    description: "Professional lunch and dinner solutions that impress clients and teams.",
    icon: Briefcase
  }, {
    title: "Eventos Familiares",
    description: "Warm, authentic dishes for reunions, baptisms, and parties.",
    icon: Users
  }];
  return <section id="indy-service-circle" ref={ref} className={cn("bg-background py-20 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6">
        {}
        <h2 className="mb-16 text-center text-3xl font-bold tracking-tight text-secondary md:text-4xl lg:text-5xl">Sirviendo a Nuestra Comunidad</h2>

        {}
        <div className="mb-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center">
              <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-background shadow-sm ring-1 ring-border/50">
                <service.icon strokeWidth={1.25} className="h-10 w-10 text-[var(--color-chart-3)]" />
              </div>
              <h3 className="mb-3 text-xl font-semibold text-foreground">
                {service.title}
              </h3>
              <p className="max-w-[240px] text-sm leading-relaxed text-muted-foreground">
                {service.description}
              </p>
            </div>)}
        </div>

        {}
        <div className="text-center">
          <p className="font-serif text-xl italic text-muted-foreground md:text-2xl">Servimos Indianapolis, Carmel, Fishers, y mas!</p>
        </div>
      </div>
    </section>;
}